module.exports = __webpack_public_path__ + "img/frolova.aef3a00c.jpg";